import localDB from "./localDB";

let GLOBAL = require('./globals');

const RecipeStockData = {
    async list(search) {
        let response = await fetch(`${GLOBAL.BASE_URL}recipes-stock?name=${search}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async listByRecipe(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}recipe-stock/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async stock(page, pk) {
        let response = await fetch(`${GLOBAL.BASE_URL}recipe-stock/${pk}?page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}recipe-stock/update`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}recipe-stock/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default RecipeStockData;



// WEBPACK FOOTER //
// ./src/data/RecipeStockData.js